/**
 * FeaturedBlogSlider
 * Extends SliderComponent to provide specific slider functionality for the featured blog section.
 */
if (!customElements.get('featured-blog-slider')) {
  class FeaturedBlogSlider extends SliderComponent {
    constructor() {
      super();
    }
  }

  customElements.define('featured-blog-slider', FeaturedBlogSlider);
}
